// --- src/App.js ---

import { MoveLeft, Search, Undo, Redo } from 'lucide-react'; // Added Undo, Redo
import "./App.css";
import { Routes, Route, Navigate } from 'react-router-dom';
import Menu from './components/Menu';
import ArtifactPage from './ArtifactPage';

function App() {
  return (
    <div className="App">
      <Menu />

      {/* --- Static Command Center UI (Desktop Only) --- */}
      {/* UPDATED: Removed justify-center, group centered with mx-auto */}
      <div className="hidden lg:flex fixed top-0 left-0 right-0 z-50  border-b border-gray-700 bg-gray-800 lg:ml-60">
        <div className="items-center lg:flex px-4 py-2.5 w-full h-full relative after:content-[''] after:absolute after:inset-0 after:bg-black/25 after:z-10 after:pointer-events-none">
          {/* UPDATED: Wrapper div for centering the input + buttons group */}
          <div className="flex items-center space-x-3 mx-auto "> {/* Added mx-auto for centering, space-x-3 for gap */}
              {/* Command Input */}
              <div className="flex items-center space-x-2 bg-gray-700 rounded-md px-3 w-full max-w-lg lg:min-w-[500px] h-8"> {/* max-w-lg remains */}
                <Search size={14} className="text-gray-400 flex-shrink-0" />
                <span className="text-gray-400 text-sm flex-grow">Open Command Menu (not active)</span>
                <span className="inline-flex items-center space-x-0.5 bg-gray-600 text-gray-300 rounded px-1 py-0.5 text-xs font-mono">
                    <span className="text-base leading-[0px] mt-[2px]">⌘</span>
                    <span>K</span>
                </span>
              </div>
              {/* NEW: Undo/Redo Buttons (Copied from Menu.js for desktop view) */}
              <div className="flex space-x-2 flex-shrink-0">
                <button className="p-1.5 text-gray-400 bg-gray-700 hover:bg-gray-600 rounded" disabled title="Undo (not available in static prototype)"> <Undo size={16} /> </button>
                <button className="p-1.5 text-gray-400 bg-gray-700 hover:bg-gray-600 rounded" disabled title="Redo (not available in static prototype)"> <Redo size={16} /> </button>
              </div>
          </div>
        </div>
      </div>
      {/* --- END: Static Command Center UI --- */}

      {/* Main Content Padding - No change needed here */}
      <div className="lg:ml-60 pt-12 lg:pt-12 relative top-1">
        {/* Red Notice Stripe */}
        <div className="bg-red-500 text-white p-2 pt-3.5 lg:pt-2 text-center font-semibold text-sm">
          This is a static UI prototype.  No data can be modified, and AI features are simulated&nbsp;|&nbsp;Blue links and artifacts in menu are clickable
        </div>
        {/* Routes */}
        <Routes>
          <Route path="/" element={<Navigate to="/artifact/restaurant-app-market-research" replace />} />
          <Route path="/artifact/:artifactId" element={<ArtifactPage />} />
        </Routes>
        {/* Footer */}
        <footer className="bg-gray-200 text-gray-600 py-2 px-4 text-center text-xs md:text-sm">
          CrossContext AI UX Demo: A static prototype showcasing cross-context information management and AI interaction.
          <br/>
          © Vladyslav D. Kryzhnii (Владислав Дмитрович Крижній), 2025. All rights reserved.
        </footer>
      </div>
    </div>
  );
}

export default App;